import React from "react";

const InputField = ({
  pattern,
  required = true,
  onChange,
  value,
  error,
  note,
  title,
  type,
  placeholder,
  id,
  name,
  
}) => {
  return (
    <div className="input__box">
      <label className="input__label" htmlFor="email">
        {title}{" "}
        {note && (
          <span
            style={{ fontSize: "1.2rem", color: "red", marginLeft: "1rem" }}
          >
            {" "}
            {note}{" "}
          </span>
        )}
      </label>

      <input
        pattern={pattern}
        required={required}
        id={id}
        type={type ? `${type}` : "text"}
        className="input__field "
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder ? placeholder : ""}
        style={{ background: "#FAFAFA", border: "2px solid #E0E0E0" }}
      />
      {error && (
        <span style={{ fontSize: "1.5rem", color: "red", marginLeft: "1rem" }}>
          {error}
        </span>
      )}
    </div>
  );
};
export default InputField;
